<template>
  <section class="system-compatible-steps">
    <div class="system-compatible-steps-description">
      <faq-header
        class="system-compatible-steps-description-heading"
        :show-link="showLink"
      />
      <faq-scalable-description
        :zoom-level-err="true"
        class="system-compatible-steps-scalable-description"
      />
    </div>
    <div class="system-compatible-steps-image">
      <img
        v-if="os.os_name === 'Windows'"
        src="https://drive.google.com/uc?export=view&id=1gUigwq4scScT5SX7Ti7PoF5PA8hPgsnm"
        class="system-compatible-steps-image-steps"
        :alt="os.os_name"
        @click="
          expandImage(
            'https://drive.google.com/uc?export=view&id=1gUigwq4scScT5SX7Ti7PoF5PA8hPgsnm'
          )
        "
      />
      <img
        v-if="os.os_name === 'Linux'"
        src="https://drive.google.com/uc?export=view&id=1FgMyB1w8NqgO4dQtL_nXT5Kkr5NJLGJf"
        class="system-compatible-steps-image-steps"
        :alt="os.os_name"
        @click="
          expandImage(
            'https://drive.google.com/uc?export=view&id=1FgMyB1w8NqgO4dQtL_nXT5Kkr5NJLGJf'
          )
        "
      />
      <img
        v-if="os.os_name === 'Mac OS'"
        src="https://drive.google.com/uc?export=view&id=10WK5xzDl-6od8beTUzMKiGVUFQFTWtI-"
        class="system-compatible-steps-image-steps"
        :alt="os.os_name"
        @click="
          expandImage(
            'https://drive.google.com/uc?export=view&id=10WK5xzDl-6od8beTUzMKiGVUFQFTWtI-'
          )
        "
      />
    </div>
    <div style="clear: both"></div>
  </section>
</template>
<script>
export default {
  name: 'StepsResolution',
  props: [ 'os' ],
  data: function() {
    return {
      showLink: true,
    }
  },
  methods: {
    expandImage: imageUrl => {
      window.open(imageUrl, '_blank')
    },
  },
}
</script>
<style scoped>
.browser-description {
  margin-bottom: 2px;
}
.compatibility-warning {
  padding: 1vw;
  padding-top: 0px;
  color: red;
}
.system-compatible-steps {
  background-color: #f1ebeb;
  height: 110%;
  width: 100%;
  border-radius: 3vw;
}
.system-compatible-steps-description,
.system-compatible-steps-image {
  box-sizing: border-box;
  padding: 1vw;
  padding-right: 0px;
  margin: auto;
}

.system-compatible-steps-description {
  width: 23%;
  text-align: left;
  float: left;
  font-size: 1.1vw;
  height: 65vh;
  overflow: auto;
}
.system-compatible-steps-image {
  width: 77%;
  float: right;
  overflow-y: scroll;
  height: 66vh;
}
.system-compatible-steps-scalable-description {
  padding: 1vw;
  font-size: 1vw;
}

.system-compatible-steps-image-steps {
  border-radius: 1vw;
  width: 95%;
}
.system-compatible-steps-image > img {
  cursor: pointer;
}
.system-compatible-steps-description-heading {
  font-size: 1vw;
}
@media only screen and (max-width: 1050px) {
  .system-compatible-steps-scalable-description,
  .browser-description,
  .compatibility-warning {
    font-size: 1.3vw;
  }
}
@media only screen and (max-width: 950px) {
  .system-compatible-steps-description-heading {
    font-size: 1.5vw;
  }
}

@media only screen and (max-width: 850px) {
  .system-compatible-steps-scalable-description,
  .browser-description,
  .compatibility-warning {
    font-size: 1.5vw;
  }
  .system-compatible-steps-description-heading {
    font-size: 1.7vw;
  }
}
@media only screen and (max-width: 800px) {
  .system-compatible-steps-scalable-description,
  .browser-description,
  .compatibility-warning {
    font-size: 1.6vw;
  }
  .system-compatible-steps-description {
    height: 60vh;
  }
  .system-compatible-steps-image {
    height: 60vh;
  }
  .system-compatible-steps-description-heading {
    font-size: 1.8vw;
  }
}
@media only screen and (max-width: 600px) {
  .system-compatible-steps-scalable-description,
  .browser-description,
  .compatibility-warning {
    font-size: 1.8vw;
  }
  .system-compatible-steps-description-heading {
    font-size: 2.5vw;
  }
  .system-compatible-steps-description {
    height: 54vh;
  }
  .system-compatible-steps-image {
    height: 54vh;
  }
}
@media only screen and (max-width: 550px) {
  .system-compatible-steps-scalable-description,
  .browser-description,
  .compatibility-warning {
    font-size: 2vw;
  }
  .system-compatible-steps-description {
    height: 50vh;
  }
  .system-compatible-steps-image {
    height: 50vh;
  }
}
@media only screen and (max-width: 500px) {
  .system-compatible-steps-scalable-description,
  .browser-description,
  .compatibility-warning {
    font-size: 2.2vw;
  }
}
</style>
